import styled from "styled-components";

export const LinksSocial = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 12px;
`;
